// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","cardMini":"Card_cardMini__2z_Kx","cardDisabled":"Card_cardDisabled__hOmTJ"};